export const isMobileDevice = () => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (window.innerWidth <= 767) {
      return true
    }
  }
  return false
}

export const isTabletDevice = () => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (window.innerWidth >= 768 && window.innerWidth <= 1023) {
      return true
    }
  }
  return false
}

export const isMediumDesktopDevice = () => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (window.innerWidth >= 1024 && window.innerWidth <= 1279) {
      return true
    }
  }
  return false
}

export const isDesktopDevice = () => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (window.innerWidth >= 1280) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/components/IbcArcade/TestimonialSection/responsiveUtils.js